/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dates_TbcInputs */

const th_dates_tbc = /** @type {(inputs: Dates_TbcInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`รอประกาศวันแข่ง`)
};

const en_dates_tbc = /** @type {(inputs: Dates_TbcInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dates TBC`)
};

const ja_dates_tbc = /** @type {(inputs: Dates_TbcInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`日程未定`)
};

const zh_dates_tbc = /** @type {(inputs: Dates_TbcInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`日期待定`)
};

const es_dates_tbc = /** @type {(inputs: Dates_TbcInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fechas por confirmar`)
};

const pt_dates_tbc = /** @type {(inputs: Dates_TbcInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Datas a confirmar`)
};

const id_dates_tbc = /** @type {(inputs: Dates_TbcInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tanggal belum ditentukan`)
};

const fr_dates_tbc = /** @type {(inputs: Dates_TbcInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dates à confirmer`)
};

const tl_dates_tbc = /** @type {(inputs: Dates_TbcInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wala pang petsa`)
};

const vi_dates_tbc = /** @type {(inputs: Dates_TbcInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chưa có ngày`)
};

const ko_dates_tbc = /** @type {(inputs: Dates_TbcInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`날짜 미정`)
};

const de_dates_tbc = /** @type {(inputs: Dates_TbcInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Termine offen`)
};

const ru_dates_tbc = /** @type {(inputs: Dates_TbcInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Даты не определены`)
};

const tr_dates_tbc = /** @type {(inputs: Dates_TbcInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tarih belirsiz`)
};

const it_dates_tbc = /** @type {(inputs: Dates_TbcInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Date da definire`)
};

const pl_dates_tbc = /** @type {(inputs: Dates_TbcInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Terminy do ustalenia`)
};

const uk_dates_tbc = /** @type {(inputs: Dates_TbcInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Дати не визначено`)
};

const hi_dates_tbc = /** @type {(inputs: Dates_TbcInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`तारीख़ें तय नहीं`)
};

const ar_dates_tbc = /** @type {(inputs: Dates_TbcInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`المواعيد غير محددة`)
};

const ms_dates_tbc = /** @type {(inputs: Dates_TbcInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tarikh belum ditetapkan`)
};

const bn_dates_tbc = /** @type {(inputs: Dates_TbcInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`তারিখ ঠিক হয়নি`)
};

const zh_tw2_dates_tbc = /** @type {(inputs: Dates_TbcInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`日期未定`)
};

const zh_hk2_dates_tbc = /** @type {(inputs: Dates_TbcInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`日期未定`)
};

const ur_dates_tbc = /** @type {(inputs: Dates_TbcInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تاریخیں طے نہیں`)
};

const fa_dates_tbc = /** @type {(inputs: Dates_TbcInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تاریخ‌ها مشخص نیست`)
};

const sw_dates_tbc = /** @type {(inputs: Dates_TbcInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tarehe hazijapangwa`)
};

const nl_dates_tbc = /** @type {(inputs: Dates_TbcInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Data nog onbekend`)
};

/**
* | output |
* | --- |
* | "Dates TBC" |
*
* @param {Dates_TbcInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const dates_tbc = /** @type {((inputs?: Dates_TbcInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dates_TbcInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_dates_tbc(inputs)
	if (locale === "ja") return ja_dates_tbc(inputs)
	if (locale === "zh") return zh_dates_tbc(inputs)
	if (locale === "es") return es_dates_tbc(inputs)
	if (locale === "pt") return pt_dates_tbc(inputs)
	if (locale === "id") return id_dates_tbc(inputs)
	if (locale === "fr") return fr_dates_tbc(inputs)
	if (locale === "tl") return tl_dates_tbc(inputs)
	if (locale === "vi") return vi_dates_tbc(inputs)
	if (locale === "ko") return ko_dates_tbc(inputs)
	if (locale === "de") return de_dates_tbc(inputs)
	if (locale === "ru") return ru_dates_tbc(inputs)
	if (locale === "tr") return tr_dates_tbc(inputs)
	if (locale === "it") return it_dates_tbc(inputs)
	if (locale === "pl") return pl_dates_tbc(inputs)
	if (locale === "uk") return uk_dates_tbc(inputs)
	if (locale === "hi") return hi_dates_tbc(inputs)
	if (locale === "ar") return ar_dates_tbc(inputs)
	if (locale === "ms") return ms_dates_tbc(inputs)
	if (locale === "bn") return bn_dates_tbc(inputs)
	if (locale === "zh-TW") return zh_tw2_dates_tbc(inputs)
	if (locale === "zh-HK") return zh_hk2_dates_tbc(inputs)
	if (locale === "ur") return ur_dates_tbc(inputs)
	if (locale === "fa") return fa_dates_tbc(inputs)
	if (locale === "sw") return sw_dates_tbc(inputs)
	if (locale === "nl") return nl_dates_tbc(inputs)
	return en_dates_tbc(inputs)
});